export enum OrbitEditProjectStep {
  FORM,
  REVIEW_FORM,
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  EDITED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  DEADLINE_EXCEEDED,
  REJECTED_BY_THE_USER,
}
